import React, { Fragment, useState, useEffect, useContext } from 'react';
import { ProjectContext } from '../../../../../context/Project';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';

function ContinueButton(props) {
    const navigate = useNavigate();
    const { project } = useContext(ProjectContext);

    const [buttonEnabled, setButtonEnabled] = useState(false);

    useEffect(() => {
        setButtonEnabled(shouldEnableButton())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project]);

    const shouldEnableButton = () => {
        return project.description?.length > 0;
    }
    
    return (
        <Fragment>
            {
                <Button disabled={!buttonEnabled}
                    onClick={() => {
                        navigate(
                            '/project/create/contractor/choose'
                        )
                    }}
                    {...props}
                >
                    Continue
                </Button>
            }
        </Fragment>
    );
}

export default ContinueButton;